import { render } from "./printer-settings.vue?vue&type=template&id=13f80186"
import script from "./printer-settings.vue?vue&type=script&lang=js"
export * from "./printer-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__